// extracted by mini-css-extract-plugin
export default {"root":"PortfolioDetails_root__ivMNy","header":"PortfolioDetails_header__33M7Y","edit":"PortfolioDetails_edit__-otoe"};